import { toCurrency } from "../../../helpers";
import {
  IGetBillingReceiptBackendModel,
  IGetBillingReceiptFrontendModel,
} from "../types";
import UserDefaultLogo from "../../../assets/svg/user-avatar.svg";
import SchoolDefaultLogo from "../../../assets/img/school-default-logo.png";
import { EducationType } from "../../school/constants/types";
import { LANGUAGES } from "../../language-course/constants";

export function parseToBillingFrontEndModel(
  data: IGetBillingReceiptBackendModel[],
): IGetBillingReceiptFrontendModel[] {
  return data.map((receipt) => {
    const defaultAvatar = receipt.application.student
      ? UserDefaultLogo
      : SchoolDefaultLogo;
    const avatar =
      receipt.application.student?.photo?.preview ||
      receipt.application.program?.academic?.school?.image?.preview ||
      receipt.application.course?.school?.image?.preview ||
      defaultAvatar;

    switch (receipt.schoolType) {
      case EducationType.Language:
        return {
          id: receipt.id,
          schoolType: receipt.schoolType,
          amountWithCurrency: toCurrency(
            receipt.amount,
            receipt.currency,
          ) as string,
          studentName: receipt.application.student?.name,
          avatar: avatar,
          receiptImage: receipt.image?.preview,
          schoolName: receipt.application.course!.school?.name,
          language: LANGUAGES.find(
            (l) => l.id === receipt.application.course!.language,
          )!.name,
          category: receipt.application.course!.category,
        };
      case EducationType.Secondary:
      case EducationType.Higher:
        return {
          id: receipt.id,
          schoolType: receipt.schoolType,
          amountWithCurrency: toCurrency(
            receipt.amount,
            receipt.currency,
          ) as string,
          studentName: receipt.application.student?.name,
          avatar: avatar,
          receiptImage: receipt.image?.preview,
          schoolName: receipt.application.program!.academic.school?.name,
          degreeName: receipt.application.program!.academic.degreeName,
          levelName: receipt.application.program!.academic.levelName,
          majorName: receipt.application.program!.majorName,
          grade: receipt.application.program!.academic.grade,
        };
    }
  });
}
